import TrackChangesOutlined from "@mui/icons-material/TrackChangesOutlined";
import { useSearch } from "wouter";

import { useGetSavingsGoalsQuery } from "../../../services";

import {
  GOALS_VIEW_PARAM,
  HEALTH_TARGET_PARAM,
  ROLL_FORWARD_PARAM,
} from "../constants";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
  IconContainer,
  TitleRow,
} from "../styles";
import { HealthTargets } from "./HealthTargets";
import { isHealthTargetMetric } from "./healthTargetsConfig";
import { InvestmentGoals } from "./InvestmentGoals";
import { SavingsGoals } from "./SavingsGoals";
import { Groups } from "./styles";

export const GoalsSection = () => {
  const params = new URLSearchParams(useSearch());
  const target = params.get(HEALTH_TARGET_PARAM);
  const focusMetric = isHealthTargetMetric(target) ? target : undefined;
  const showPast = params.get(GOALS_VIEW_PARAM) === "past";
  const rollForwardParam = Number(params.get(ROLL_FORWARD_PARAM));
  const rollForwardGoalId =
    Number.isInteger(rollForwardParam) && rollForwardParam > 0
      ? rollForwardParam
      : undefined;
  const { data: savingsGoals } = useGetSavingsGoalsQuery();
  // Savings renders first, so its Past goals toggle owns the scroll unless it has none.
  const hasNoPastSavingsGoals =
    savingsGoals?.every(({ closedAt }) => closedAt === null) ?? false;

  return (
    <Card className="goals">
      <CardHeader>
        <TitleRow>
          <IconContainer>
            <TrackChangesOutlined />
          </IconContainer>
          <CardTitle>Goals</CardTitle>
        </TitleRow>
        <CardDescription>
          Set targets for your savings and investments and see how close you
          are.
        </CardDescription>
      </CardHeader>
      <Groups>
        <SavingsGoals
          showPast={showPast}
          rollForwardGoalId={rollForwardGoalId}
        />
        <InvestmentGoals
          showPast={showPast}
          isPastScrollTarget={showPast && hasNoPastSavingsGoals}
        />
        <HealthTargets focusMetric={focusMetric} />
      </Groups>
    </Card>
  );
};
